module.exports = __webpack_public_path__ + "static/media/icons-dark-gray-star-filled.3710cd5b.svg";